<template>
  <div>
    <!-- 视频AI事件报警设置 -->
    <div class="title-box">臭氧度报警明细</div>
    <!-- 查询条件 -->

    <el-form
      id="aiAlarmDetailForm"
      :inline="true"
      :model="formData"
      style="border-radius: 3px; margin-bottom: 10px; box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1)"
      class="demo-form-inline"
    >
      <el-row>
        <el-form-item prop="factoryId">
          <el-select
            v-model="formData.factoryId"
            filterable
            placeholder="选择工厂"
            clearable
            @change="getWorkshopByFactory"
          >
            <el-option v-for="item in factoryOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="workshopId">
          <el-select
            v-model="formData.workshopId"
            filterable
            clearable
            placeholder="选择车间"
            @change="getSceneByWorkshop"
          >
            <el-option v-for="item in workshopOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="sceneId">
          <el-select placeholder="选择场景" v-model="formData.sceneId" clearable filterable>
            <el-option v-for="item in sceneOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="formData.alarmStartTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="formData.alarmEndTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select placeholder="报警持续时长" v-model="formData.alarmDuration" clearable filterable>
            <el-option v-for="item in alarmDurations" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      :style="{ height: tableHeight + 'px', width: '100%', 'border-radius': '3px' }"
      class="custom-table-header"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
      <el-table-column prop="factoryName" label="工厂" align="center"></el-table-column>
      <el-table-column prop="workshopName" label="车间" align="center"></el-table-column>
      <el-table-column prop="sceneName" label="场景" align="center"></el-table-column>
      <el-table-column prop="alarmStartTime" label="报警开始时间" align="center"></el-table-column>
      <el-table-column prop="alarmDurationStr" label="报警持续时长" width="100" align="center"></el-table-column>
      <el-table-column prop="alarmEndTime" label="报警结束时间" align="center"></el-table-column>
      <el-table-column prop="ozoneAvgConcentration" label="臭氧平均浓度" align="center"></el-table-column>
      <el-table-column prop="ozoneMaxConcentration" label="臭氧最高浓度" align="center"></el-table-column>
      <el-table-column prop="disinfectionStandard" label="消杀标准浓度" align="center"></el-table-column>
      <el-table-column prop="ozoneConcentrationDeviation" label="浓度偏差" align="center"></el-table-column>
      <el-table-column prop="pushUserCount" label="报警人推送人数" align="center"></el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="block" style="background: #fff; text-align: center; padding: 20px 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
import api from '@/utils/api';
import { Message, MessageBox } from 'element-ui';

export default {
  data() {
    return {
      // 查询条件
      formData: {
        factoryId: '',
        workshopId: '',
        sceneId: '',
        alarmStartTime: '',
        alarmEndTime: '',
        alarmDuration: ''
      },
      //工厂数据
      factoryOptions: [],
      // 车间数据
      workshopOptions: [],
      sceneOptions: [],
      currentPage: 1,
      pageSize: 100,
      total: 0,
      tableHeight: 650,
      // 表格数据
      tableData: [],
      loading: false,
      alarmDurations: [
        {
          label: '>5分钟',
          value: 5
        },
        {
          label: '>15分钟',
          value: 15
        },
        {
          label: '>30分钟',
          value: 30
        },
        {
          label: '>60分钟',
          value: 60
        },
        {
          label: '>120分钟',
          value: 120
        },
        {
          label: '>240分钟',
          value: 240
        },
        {
          label: '>24小时',
          value: 24
        }
      ]
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    this.getList();
    this.getFactoryByCustomer();
  },
  methods: {
    // 监听窗口缩放
    handleResize() {
      // 当窗口大小变化时，这个函数会被调用
      const height = window.innerHeight;
      // 你可以在这里添加你的处理代码
      let dom = document.getElementById('aiAlarmDetailForm');
      let formH = 70; //一行时高度为70
      if (dom) {
        formH = dom.offsetHeight;
      }
      this.tableHeight = height - 191 - formH; //表单的高度会变化

      if (this.lineChart) {
        this.lineChart.resize();
      }
    },
    // 查询
    onSubmit() {
      this.getList();
    },
    // 重置
    onReset() {
      this.formData = {
        factoryId: '',
        workshopId: '',
        sceneId: '',
        alarmStartTime: '',
        alarmEndTime: '',
        alarmDuration: ''
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    // 根据客户查询工厂
    getFactoryByCustomer() {
      this.$store
        .dispatch('workshop/getFactoryByCustomer')
        .then((result) => {
          if (result.code === 200 && result.data.length) {
            this.factoryOptions = result.data;
          } else {
            this.factoryOptions = [];
          }
        })
        .catch((err) => {
          this.factoryOptions = [];
        });
    },
    // 根据工厂查询车间
    getWorkshopByFactory() {
      this.$store
        .dispatch('scene/getWorkshopByFactory', { factoryId: this.formData.factoryId })
        .then((result) => {
          this.formData.workshopId = '';
          if (result.code === 200 && result.data && result.data.length > 0) {
            this.workshopOptions = result.data;
          } else {
            this.workshopOptions = [];
          }
        })
        .catch((err) => {
          this.workshopOptions = [];
        });
    },
    // 根据车间查询场景
    getSceneByWorkshop() {
      this.$store
        .dispatch('monitorData/getSceneByWorkshop', { workshopId: this.formData.workshopId })
        .then((result) => {
          this.formData.sceneId = null;
          if (result.code === 200 && result.data && result.data.length > 0) {
            this.sceneOptions = result.data;
          } else {
            this.sceneOptions = [];
          }
        })
        .catch((err) => {
          this.sceneOptions = [];
        });
    },
    refreshTable() {
      this.getList();
    },
    getList() {
      const params = {
        factoryId: this.formData.factoryId,
        workshopId: this.formData.workshopId,
        sceneId: this.formData.sceneId,
        alarmStartTime: this.formData.alarmStartTime,
        alarmEndTime: this.formData.alarmEndTime,
        alarmDuration: this.formData.alarmDuration,
        pageSize: this.pageSize,
        pageNum: this.currentPage
      };
      this.loading = true;
      request
        .get(`${api.alarmDetail.getOzoneDetectorList}`, {
          params: params
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = (res.rows || []).map((item) => {
              return {
                id: item.id,
                factoryId: item?.factoryId,
                factoryName: item.factoryName,
                workshopId: item?.workshopId,
                workshopName: item.workshopName,
                sceneId: item?.sceneId,
                sceneName: item.sceneName,
                alarmStartTime: item?.alarmStartTime,
                alarmDurationStr: item?.alarmDurationStr,
                alarmEndTime: item?.alarmEndTime,
                ozoneConcentrationValue: item?.ozoneConcentrationValue,
                ozoneAvgConcentration: item?.ozoneAvgConcentration,
                ozoneMaxConcentration: item?.ozoneMaxConcentration,
                disinfectionStandard: item?.disinfectionStandard,
                ozoneConcentrationDeviation: item?.ozoneConcentrationDeviation,
                pushUserCount: item?.pushUserCount
              };
            });
            this.total = res.total;
            this.loading = false;
          } else {
            this.tableData = [];
            this.total = 0;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.tableData = [];
          this.total = 0;
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.title-box {
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  padding: 27px 0 15px;
  line-height: 16px;
}
.params-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
// 表头背景色
::v-deep .custom-table-header th {
  background-color: #ebeef5 !important;
}
// 表格字体大小
.el-table {
  font-size: 12px;
}
// 表单底部边界线
.el-table::before {
  height: 0px;
}
// 表格字体
::v-deep .el-table thead {
  color: #606266;
}
// 表格内边距
::v-deep .el-table .el-table__cell {
  padding: 8px 0;
}
// 表单底部margin
.el-form-item {
  margin-bottom: 0;
}
// 当前页码样式
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ff9f07;
}
// 页面hover样式
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #ff9f07;
}
// .el-button{
//     font-size: 12px;
// }
::v-deep .el-form-item__label {
  font-size: 12px;
}
::v-deep .el-table__body-wrapper {
  height: 100%;
  overflow-y: auto;
}
.tool-icon {
  width: 28px;
  height: 32px;
  cursor: pointer;
  background: #c7c7c7;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  border-radius: 4px;
  margin-left: 5px;
}
.select-icon {
  background: #3083fb;
}
</style>
